import styled from 'styled-components';

export const Container = styled.div`
  overflow: auto;
  padding: 24px 36px;
  height: 100%;
`;
